import { IFile } from './generic';

export interface IAccountCreatorEdit {
  _method: string;
  title: string;
  logo: {
    file: File;
  };
  'logo[image_1]'?: IFile;
  banner: {
    file: File;
  };
  'banner[image_1]'?: IFile;
  bio: string;
  string: string;
  twitter: string;
  facebook: string;
  pinterest: string;
  instagram: string;
  linkedin: string;
  website: string;
  discord: string;
  bank_account_number: string;
  user_name: string;
}

export interface IAccountCreatorResponse {
  account_type: AccountType;
  message?: string;
  id: number;
  address: string;
  title: string;
  user_name: string;
  full_name?: string;
  bank_account_number: string | null;
  logo_url: string;
  banner_url: string;
  verified: string;
  verified_request: string;
  bio: string;
  twitter: string;
  facebook: string;
  pinterest: string;
  instagram: string;
  linkedin: string;
  website: string;
  discord: string;
  used_free_mints: number;
  allowed_free_mints: number;
  customer: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    gender: string;
    date_of_birth: string;
    phone: string;
    status: string;
    created_at: string;
    updated_at: string;
  };
  created_at: string;
  updated_at: string;
  nft_owned: number;
}

export enum AccountType {
  User = 'user',
  Creator = 'creator',
  Company = 'company'
}
